<template>
  <x-dialog
    width="70%"
    dialogTitle="Settings"
    :dialogState="dialogOpen"
    @toggleModal="closeDialog"
    :actions="{
      show: true,
      secondaryButtonFunction: closeDialog,
      primaryButtonFunction: sendThemeData,
      primaryButtonShow: true,
      secondaryButtonText: 'Cancel',
      primaryButtonText: 'Save settings'
    }"
  >
    <template slot="dialog_data">
      <v-card-text class="px-10">
        <v-row>
          <v-col>
            <label class="formInputLabel">Theme</label>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="item in themeTypeData" :key="item.index">
            <v-card
              tile
              elevation="0"
              class="graphTypeCard"
              justify="center"
              @click.native="selectThemeType(item)"
              :class="{ active: item.title === toggle_themeType }"
            >
              <v-card-text class="pa-0">
                <img :src="item.imgSrc" width="auto" />
              </v-card-text>
              <v-card-title class="body-1 graphTypeCardTitle py-1 px-3">{{
                item.title
              }}</v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </template>
  </x-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean
    }
  },
  computed: {
    dialogOpen() {
      return this.dialog;
    }
  },
  data() {
    return {
      darkTheme: false,
      toggle_themeType: null,
      themeTypeData: [
        {
          title: 'Light',
          imgSrc: require('@/assets/images/theme--light/light-theme-icon.svg')
        },
        {
          title: 'Dark',
          imgSrc: require('@/assets/images/theme--dark/dark-theme-icon.svg')
        }
      ]
    };
  },
  created: function() {
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  methods: {
    closeDialog() {
      this.$emit('updateDialog', false);
    },
    escapeKeyListener: function(evt) {
      if (evt.keyCode === this.escapeKeyCode && this.dialog) {
        this.closeDialog();
      }
    },
    sendThemeData() {
      localStorage.setItem('selectedTheme', this.toggle_themeType);
      if (this.toggle_themeType === 'Dark') {
        document.getElementById('themeLight').setAttribute('disabled', false);
        document.getElementById('themeDark').removeAttribute('disabled');
      } else {
        document.getElementById('themeDark').setAttribute('disabled', false);
        document.getElementById('themeLight').removeAttribute('disabled');
      }
      this.closeDialog();
    },
    selectThemeType(item) {
      this.darkTheme = item.title === 'Dark' ? true : false;
      this.toggle_themeType = item.title;
    }
  },
  mounted() {
    this.toggle_themeType = localStorage.getItem('selectedTheme') || 'Light';
  }
};
</script>
